import 'nprogress/nprogress.css';

import { datadogRum } from '@datadog/browser-rum';

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
baseConfig.NODE_ENV === 'production' &&
  datadogRum.init({
    applicationId: baseConfig.DATADOG_APPLICATION_ID,
    clientToken: baseConfig.DATADOG_CLIENT_TOKEN,
    site: baseConfig.DATADOG_SITE,
    service: 'captur-dashboard',
    env: baseConfig.NODE_ENV,
    version: baseConfig.RELEASE_SHA,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  });

import * as Sentry from '@sentry/react';
import { SnackbarProvider } from 'notistack';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate } from 'react-router-dom';
import App from 'src/App';
import { AuthProvider } from 'src/contexts/JWTAuthContext';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import ScrollTop from 'src/hooks/useScrollTop';
import * as serviceWorker from 'src/serviceWorker';
import store from 'src/store';

import { baseConfig } from './config';
import { PosthogAnalytics } from './utils/posthogAnalytics';

const isDev = baseConfig.NODE_ENV === 'development';

if (!isDev) {
  PosthogAnalytics.initialise();
}

Sentry.init({
  environment: baseConfig.NODE_ENV,
  dsn: baseConfig.SENTRY_DSN_DASHBOARD,
  release: `Captur-DASHBOARD@${baseConfig.RELEASE_SHA}`,
  integrations: [
    new posthog.SentryIntegration(
      posthog,
      baseConfig.SENTRY_ORGANISATION,
      Number(baseConfig.SENTRY_PROJECTID_DASHBOARD)
    )
  ]
});

ReactDOM.render(
  <HelmetProvider>
    <SnackbarProvider
      maxSnack={6}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      preventDuplicate
    >
      <Provider store={store}>
        <SidebarProvider>
          <BrowserRouter>
            <Sentry.ErrorBoundary
              fallback={({ resetError }) => {
                if (isDev) return;
                resetError();
                return <Navigate to="/status/500" />;
              }}
              showDialog={!isDev}
            >
              <ScrollTop />
              <AuthProvider>
                {isDev ? (
                  <App />
                ) : (
                  <PostHogProvider client={posthog}>
                    <App />
                  </PostHogProvider>
                )}
              </AuthProvider>
            </Sentry.ErrorBoundary>
          </BrowserRouter>
        </SidebarProvider>
      </Provider>
    </SnackbarProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

// document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');

serviceWorker.unregister();
